module.exports = {
	"FREIGHT": {
		"FRONT_DOOR": "Delivered to front door of your house or building and does not include unpacking, inspection, assembly, or installation. Facilitated by {facilitatedBy}."
	},
	"PARCEL": {
		"STANDARD": "Carefully packaged and delivered via a parcel delivery service such as UPS or FedEx. Facilitated by {facilitatedBy}.",
		"EXPRESS": "Carefully packaged and delivered via a parcel delivery service such as UPS or FedEx. Facilitated by {facilitatedBy}.",
		"MESSENGER": "Hand-delivered via a local messenger service at a time that is convenient for you to sign for a delivery. Facilitated by {facilitatedBy}."
	},
	"WHITE_GLOVE": {
		"STANDARD": "Delivered to room of choice and includes unpacking, inspection, and minor assembly at your convenience. Facilitated by {facilitatedBy}.",
		"EXPRESS": "Delivered to room of choice and includes unpacking, inspection, and minor assembly at your convenience. Facilitated by {facilitatedBy}."
	}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/shipmentMethodDefinitions.json
// module id = 1582
// module chunks = 4 14